import { render } from "./Intro.vue?vue&type=template&id=47f49e00&scoped=true"
import script from "./Intro.vue?vue&type=script&lang=js"
export * from "./Intro.vue?vue&type=script&lang=js"

import "./Intro.vue?vue&type=style&index=0&id=47f49e00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47f49e00"]])

export default __exports__